import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const bankLogos = [
  {
    id: 'akbank',
    name: 'Akbank',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/a80c0972-6830-4dc4-b3bc-e236c7fbb5ea.png'
  },
  {
    id: 'garanti',
    name: 'Garanti BBVA',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/2cf1c9fe-fbff-4874-a365-fd63455d078c.png'
  },
  {
    id: 'yapikredi',
    name: 'Yapı Kredi',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/52f6626d-498d-4e76-8fb5-fd4381a1e0db.png'
  },
  {
    id: 'qnb',
    name: 'QNB Finansbank',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/d9ae3539-f63d-4295-84e6-08dbe6e2a6d6.png'
  },
  {
    id: 'isbankasi',
    name: 'İş Bankası',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/3b159da8-fe94-4b12-b9fa-4b9c60495305.png'
  },
  {
    id: 'ziraatbankasi',
    name: 'Ziraat Bankası',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/2c60a02b-d37c-48ce-ad8e-deb4e57bf810.jpg'
  },
  {
    id: 'nkolay',
    name: 'Nkolay',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/7accd65f-06ae-48b1-875e-6d9827590be6.png'
  }
];

interface PreferredBanksProps {
  customBanks?: Array<{
    id: string;
    name: string;
    logo: string;
  }>;
}

const PreferredBanks: React.FC<PreferredBanksProps> = ({ customBanks }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  const navigate = useNavigate();

  // Use customBanks if provided, otherwise use default bankLogos
  const displayBanks = customBanks || bankLogos;

  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider || isPaused) return;

    let animationFrameId: number;
    let lastTimestamp = 0;
    const speed = 0.5; // Pixels per millisecond

    const animate = (timestamp: number) => {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;
      
      if (slider.scrollLeft >= slider.scrollWidth / 2) {
        slider.scrollLeft = 0;
      } else {
        slider.scrollLeft += elapsed * speed;
      }
      
      lastTimestamp = timestamp;
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isPaused]);

  const handleBankClick = (bankId: string) => {
    navigate(`/bankalar/${bankId}`);
  };

  return (
    <div 
      ref={scrollRef}
      className="overflow-hidden"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="flex items-center py-8">
        <div className="flex gap-16 items-center">
          {[...displayBanks, ...displayBanks].map((bank, index) => (
            <button
              key={`${bank.id}-${index}`}
              onClick={() => handleBankClick(bank.id)}
              className="flex-shrink-0 px-4 transition-transform hover:scale-110 duration-300 flex flex-col items-center gap-3"
            >
              <img 
                src={bank.logo} 
                alt={bank.name}
                className="h-12 object-contain"
              />
              <span className="text-sm font-medium text-slate-700">{bank.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreferredBanks;